import { isFileAccepted } from './accept';
import type { UploadMessages } from './types';

/** Validate a file against type and size constraints. Returns an error string or null. */
export function validateFile(
  file: File,
  opts: { accept?: string; maxSizeMb?: number; messages?: UploadMessages },
): string | null {
  if (!isFileAccepted(file, opts.accept))
    return opts.messages?.invalidType ?? 'Please upload a valid file';
  if (opts.maxSizeMb && file.size > opts.maxSizeMb * 1024 * 1024)
    return opts.messages?.tooLarge ?? `File size should be less than ${opts.maxSizeMb}MB`;
  return null;
}
